import React, { useEffect } from "react";
import { workSample } from "../../utils/Dummy";
import { imgUrl } from "../../utils/helper";
import NODATA from "../../assets/img/nodata_icon.webp";

function WorkSample({ selected }) {
  const data = workSample.filter((item) => {
    if (selected === "All") return item;
    return item.category === selected;
  });

  return (
    <div>
      {/* work sample images */}
      {data?.length > 0 ? (
        <section
          className="mx-auto py-[10px] grid lg:grid-cols-3 sm:grid-cols-2 grid-cols-1 gap-10 my-5"
          data-aos="fade-left"
          data-aos-delay="800"
        >
          {data?.map((items, index) => {
            return (
              <div
                key={index}
                index={index}
                className="flex flex-col items-center p-8 bg-gifWhite rounded-xl shadow-sm"
              >
                <img
                  src={items?.img ? items?.img : imgUrl + "comp.png"}
                  className="h-[180px] transition-all w-full object-fill"
                  alt=""
                />
                <p className="mt-4 text-xl font-semibold"> {items.name}</p>
              </div>
            );
          })}
        </section>
      ) : (
        <div className="flex justify-center items-center mt-10">
          <img src={NODATA} alt="nodata" />
        </div>
      )}
    </div>
  );
}

export default WorkSample;
